// src/core/online/ConnectionHandler.js

const ConnectionHandler = {
    // Shows the full-screen error overlay used for critical disconnects
    showErrorOverlay: function (title, message) {
        // Prevent duplicate overlays
        if (document.getElementById('error-overlay')) return;

        const overlay = document.createElement('div');
        overlay.id = 'error-overlay';
        Object.assign(overlay.style, {
            position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.95)', display: 'flex', flexDirection: 'column',
            justifyContent: 'center', alignItems: 'center', zIndex: '20000', color: '#fff'
        });
        overlay.innerHTML = `
            <div style="text-align:center; max-width:600px; padding:20px;">
                <h1 style="color:#e74c3c; font-size:3rem; margin-bottom:20px; text-shadow:0 0 10px rgba(231,76,60,0.5);">⚠️ ${title}</h1>
                <p style="font-size:1.3rem; margin-bottom:40px; color:#ddd; line-height:1.6;">${message}</p>
                <button id="return-home-btn" style="
                    padding:15px 40px; 
                    font-size:1.2rem; 
                    background:var(--accent-gold, #ffd700); 
                    color:#000; 
                    border:none; 
                    border-radius:8px; 
                    cursor:pointer; 
                    font-weight:bold;
                    box-shadow: 0 0 20px rgba(255, 215, 0, 0.3);
                    transition: transform 0.2s;
                ">ANA SAYFAYA DÖN</button>
            </div>
        `;

        document.body.appendChild(overlay);

        // Button Listener
        const btn = overlay.querySelector('#return-home-btn');
        if (btn) {
            btn.onmouseenter = () => btn.style.transform = 'scale(1.05)';
            btn.onmouseleave = () => btn.style.transform = 'scale(1)';
            btn.onclick = () => {
                // Return to main page (hard reload to clear state)
                window.location.href = '/';
            };
        }
    },

    handleDisconnect: function (code, intentionalDisconnect) {
        console.log("ConnectionHandler: Disconnected with code =", code);

        // Bilerek çıkış yapılmışsa hata gösterme
        if (intentionalDisconnect) {
            console.log("Normal çıkış (kullanıcı tarafından), hata yok.");
            return;
        }

        // 1000: Normal Closure (Kendi isteğiyle çıkış)
        // Diğer kodlar gerçek kopmalardır.
        if (code !== 1000) {
            this.showErrorOverlay("BAĞLANTI KOPTU", "Sunucu ile bağlantınız kesildi. Lütfen sayfayı yenileyin.");
        } else {
            console.log("Normal bağlantı kapatma, overlay gösterilmedi.");
        }

        // [FIX] Clean up Chat & Scoreboard
        if (window.ChatManager) {
            console.log("ConnectionHandler: Destroying ChatManager on disconnect...");
            window.ChatManager.destroy();
        }

        const scoreContainer = document.getElementById('multi-score-container');
        if (scoreContainer) scoreContainer.remove();
    }
};

window.ConnectionHandler = ConnectionHandler;
